import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Button, { buttonColors } from '../../atoms/button';
import Typography from '../../atoms/typography';

const StyledButton = styled(Button)`
  display: flex;

  svg {
    align-self: center;
    fill: transparent;
    stroke: ${(props) => (props.isText ? props.theme.color.brand : buttonColors(props).color)};
    height: 2.7rem;
    width: 2.7rem;
    margin-right: 1rem;
  }
`;

const Text = styled(Typography)``;

const IconButton = (props) => (
  <StyledButton
    promise={props.promise}
    handleOnPromise={props.handleOnPromise}
    handleOnSuccess={props.handleOnSuccess}
    onError={props.onError}
    isText={props.isText}
    inverted={props.inverted}
    outline={props.outline}
    onClick={props.clicked}
    className={props.className}
    disabled={props.disabled}
  >
    {props.children}
    <Text element="i" like="label-1">{props.text}</Text>
  </StyledButton>
);

IconButton.defaultProps = {
  className: '',
  disabled: false,
  inverted: false,
  isText: true,
  outline: false,
  clicked: () => {},
  onError: undefined,
  handleOnPromise: undefined,
  handleOnSuccess: undefined,
  promise: undefined
};

IconButton.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  isText: PropTypes.bool,
  onError: PropTypes.func,
  handleOnPromise: PropTypes.func,
  handleOnSuccess: PropTypes.func,
  outline: PropTypes.bool,
  promise: PropTypes.func,
  text: PropTypes.string.isRequired
};

IconButton.whyDidYouRender = true;

export default IconButton;
